import { isArrayNotEmpty } from 'utilities/JSUtil';
import StringConst from '../constants/StringConst';
import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT, withQuery } from '../utilities/FetchHelper';

class HotelContactsService {

    getHotel(data) {
        const url = withQuery(URLConst.HOTEL_ONBOARDING_SERVICE, {
            hotelCode: data.hotelCode
        })
        return fetchJSON(url, secureGET()).then(response => {
            return response.hotelOnboardingDetailsList ? response.hotelOnboardingDetailsList[0] : undefined
        }).catch((error) => {
            throw error
        })
    }

    getAllHotels(status) {
        const url = withQuery(URLConst.HOTEL_ONBOARDING_SERVICE, {
            status: status
        })
        return fetchJSON(url, secureGET()).then(response => {
            return response.hotelOnboardingDetailsList ? response.hotelOnboardingDetailsList : undefined
        }).catch((error) => {
            throw error
        })
    }

    getHotelContacts(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_CONTACTS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putHotelContacts(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_CONTACTS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        const formData = data.formData

        formData.forEach((contactEntry, index) => {
            if (contactEntry["phoneNumber"]) {
                contactEntry["phoneNumbers"] = [{
                    "areaCode": contactEntry.areaCode,
                    "countryCode": contactEntry.countryCode,
                    "number": contactEntry.phoneNumber,
                    "type": contactEntry.phoneNumberType,
                    "preferred": true
                }]
            }

            if (!isArrayNotEmpty(contactEntry["phoneNumbers"])) {
                delete contactEntry["phoneNumbers"]
            }

            delete contactEntry["phoneNumber"]
            delete contactEntry["phoneType"]

            if (contactEntry["email"]) {
                contactEntry["emailAddresses"] = [{
                    "address": contactEntry.email,
                    "type": contactEntry.emailType,
                    "preferred": contactEntry.isEmailPreferred || true
                }]
            }

            if (!isArrayNotEmpty(contactEntry["emailAddresses"])) {
                delete contactEntry["emailAddresses"]
            }

            delete contactEntry["email"]
            delete contactEntry["emailType"]

            // Convert to string
            if (contactEntry["emergencyPriority"]) {
                contactEntry["emergencyPriority"] = contactEntry["emergencyPriority"] + ''
            }

            contactEntry["updatedBy"] = contactEntry["updatedBy"] || StringConst.SERVICE_NAME
            contactEntry.createdBy = StringConst.SERVICE_NAME
            contactEntry.updatedBy = StringConst.SERVICE_NAME
        })

        let putData = {
            hotelCode: data.hotelCode,
            contacts: formData,
            createdBy: StringConst.SERVICE_NAME,
            updatedBy: StringConst.SERVICE_NAME
        }

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(putData) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new HotelContactsService();